const excludedFileNames = [
  'package-lock.json',
  'yarn.lock',
  'pnpm-lock.yaml',
  'composer.lock',
  'Gemfile.lock',
  'go.sum',
  'Pipfile.lock'
]

const excludedExtensions = [
  '.lock',
  '.log',
  '.md',
  '.svg',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.pdf',
  '.zip',
  '.env',
  '.ico',
  '.woff',
  '.woff2',
  '.ttf',
  '.otf',
  '.eot'
]

const excludedDirectoryParts = [
  'node_modules/',
  'dist/',
  'build/',
  'out/',
  '.git/',
  '.vscode/',
  'coverage/',
  'public/'
]

export const isFileRelevantForAnalysis = (filePath) => {
  if (!filePath) {
    return false
  }

  const lowerCasePath = filePath.toLowerCase()
  const fileName = lowerCasePath.split('/').pop()

  if (excludedFileNames.includes(fileName)) {
    return false
  }

  for (const ext of excludedExtensions) {
    if (lowerCasePath.endsWith(ext)) {
      return false
    }
  }

  for (const dir of excludedDirectoryParts) {
    if (lowerCasePath.includes(dir)) {
      return false
    }
  }

  return true
}
